<template>
	<div
		class="notification"
		:class="{
			'notification--warning': type === 'warning',
			'notification--overflow': value && value.toString().length >= 3,
		}"
	>
		<div class="notification__bg">
			<span v-if="value" class="notification__value">{{ value }}</span>
			<AppControlIcon
				v-if="type === 'warning'"
				:iconName="IconTypes.INFO"
				:size="12"
			/>
		</div>
	</div>
</template>

<script lang="ts" setup>
import AppControlIcon from "@/components/AppControlIcon.vue";
import { IconTypes, StatusTypes } from "@/types/ui";

interface Props {
	value?: number | string;
	type?: StatusTypes;
}

const { value = null, type = StatusTypes.DEFAULT } = defineProps<Props>();
</script>

<style lang="scss">
.notification {
	@include flex-row-center;
	position: relative;
	z-index: 0;
	filter: drop-shadow(0.04rem 0.04rem 0.0625rem #000000);
	border: none;
	border-radius: 10rem;
	background-image: linear-gradient(to right, #585c77, #82869f, #585c77);
	width: 1.125rem;
	height: 1.125rem;

	&--overflow {
		width: unset;
		min-width: 1.125rem;

		.notification__value {
			margin: 0 0.25rem;
		}
	}

	&--warning {
		background-image: linear-gradient(to right, #980f0a, #ef2323, #980f0a);
		width: 0.938rem;
		height: 0.938rem;

		.notification__bg {
			background-image: radial-gradient(
				circle at center,
				#ef2323,
				#7e0000
			);
		}

		.control-icon {
			filter: drop-shadow(0.07rem 0.07rem 0.1rem rgba(0, 0, 0, 0.6));
		}
	}

	&__bg {
		@include flex-col-center;
		position: relative;
		z-index: 1;
		border-radius: 10rem;
		background-image: radial-gradient(circle at center, #828597, #45495f);
		width: calc(100% - 0.125rem);
		height: calc(100% - 0.125rem);
	}

	&__value {
		padding-bottom: 0.125rem;
		color: #fff3dd;
		font-weight: 800;
		font-size: 0.75rem;
		line-height: 0.75rem;
		user-select: none;
		text-align: center;
		text-shadow: 0.04rem 0.04rem 0.06rem rgba(0, 0, 0, 0.6);
	}
}
</style>
